/* Dr. John's site refresh (CJ 10-30): card quick add + cart quantity steppers. No dependencies. */
(function () {
  document.documentElement.classList.add('js');

  function setCount(n) {
    document.querySelectorAll('.num-items-in-cart .number, #cart-target .number').forEach(function (el) { el.textContent = n; });
  }

  // Quick add on product cards (single-variant products only)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-drj-quick-add]') || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw r; return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        if (btn) { btn.classList.add('is-added'); btn.textContent = 'Added ✓'; }
        setTimeout(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-added'); btn.innerHTML = label; } }, 1800);
      })
      .catch(function () { form.removeAttribute('data-drj-quick-add'); form.submit(); });
  });

  // Cart page quantity steppers: update automatically
  function initCart() {
    var form = document.querySelector('form[data-drj-cart]');
    if (!form) return;
    var t;
    function submitSoon() { clearTimeout(t); t = setTimeout(function () { form.submit(); }, 450); }
    form.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty-step]');
      if (!b) return;
      e.preventDefault();
      var input = b.parentNode.querySelector('input');
      var v = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-qty-step'), 10));
      input.value = v;
      submitSoon();
    });
    form.addEventListener('change', function (e) { if (e.target.matches('input[name="updates[]"]')) submitSoon(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCart); else initCart();
})();
